import React from 'react';
import { generateUniqueID } from 'web-vitals/dist/modules/lib/generateUniqueID';

import ContactFormRu from '../contact-form/contact-form-ru';
import ContactFormEn from '../contact-form/contact-form-en';
import ProjectsTargetRu from '../../data/projects-target-ru.json';
import ProjectsTargetEn from '../../data/projects-target-en.json';

import CircleSlider from '../sliders/circle-slider/circle-slider';
import AnonsSlider from '../sliders/anons-slider/anons-slider';
import MobileSlider from '../sliders/mobile-slider/mobile-slider';
import MarqueeLine from '../marquee-line/marquee-line';
import Carousel from '../sliders/carousel/carousel';

import DecorSportRotate from '../decorations/sport-rotate/sport-rotate'
import DecorRealRotate from '../decorations/real-rotate/real-rotate'
import DecorFMCGComplex from '../decorations/fmcg-complex/fmcg-complex'
import DecorFMCGLogos from '../decorations/fmcg-logos/fmcg-logos'
import DecorRealLogos from '../decorations/real-logos/real-logos'
import DecorIndustryLogos from '../decorations/industry-logos/industry-logos'

import '../services/services.scss';
import './category.scss';

import urbanPoster from '../../f/img/target/urban-poster-2.jpg';
import urbanVideo from '../../f/videos/target/urban-video-3.mp4';
import retailPoster from '../../f/img/target/retail-poster.png';
import retailVideo from '../../f/videos/target/retail-video.mp4';
import sportPoster from '../../f/img/target/sport-poster.png';
import sportVideo from '../../f/videos/target/sport-video.mp4';
import fmcgPoster from '../../f/img/target/fmcg-poster.png';
import fmcgVideo from '../../f/videos/target/fmcg-video.mp4';
import industryVideo from '../../f/videos/target/industry-video.mp4';
import industryPoster from '../../f/img/target/industry-poster.png';
import realPoster from '../../f/img/target/real-poster.jpg';
import realVideo from '../../f/videos/target/devel-video.mp4';

const CategoryTarget = ({ tag }) => {

    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    const eng = window.lang && window.lang === 'en' || (params.lang && (params.lang === 'en'));

    const projects = eng ? ProjectsTargetEn : ProjectsTargetRu;

    const goToTalkText = eng ? 'Discuss the project' : 'Обсудить проект';
    const downloadFileText = eng ? 'Download presentation' : 'Скачать презентацию';

    const {
        title,
        subTitle,
        sideColor,
        presentation,
        contentBlocks,
        сontentColor,

        formTitle,
        formSubtitle,
        formInputCompany,
        api_linkToAll,
    } = projects[tag];

    const [apiData, setApiData] = React.useState(null);
    const [apiLoading, setApiLoading] = React.useState(false);

    const navRef = React.useRef()
    const preview = React.useRef()

    const onNavClick = id => {
        const block = document.getElementById(id)
        if(block){
            block.scrollIntoView({
                behavior: "smooth",
                block: "center"
            })
        }
    }

    const formParams = React.useMemo(() => {
        return {
            formId: tag,
            title: formTitle,
            subTitle: formSubtitle,
            inputCompanyText: formInputCompany,
        }
    }, [tag, formTitle, formSubtitle, formInputCompany]);

    function showingNavigation() {
        if (!navRef || !navRef.current) {
            return
        }
        if (document.querySelector('.content-block-0')?.getBoundingClientRect().top < window.innerHeight / 2) {
            navRef.current.style.opacity = 1
            navRef.current.style.pointerEvents = 'auto'
        } else {
            navRef.current.style.opacity = 0
            navRef.current.style.pointerEvents = 'none'
        }

        if (document.querySelector('.content-block-0')?.getBoundingClientRect().top < 0) {
            preview.current.style.opacity = 0
        } else {
            preview.current.style.opacity = 1
        }
    }

    function highlightNavigation() {
        const blocks = blocksRef.current
        const navs = navsRef.current

        if (blocks.length) {
            blocks.forEach((n, i) => {
                const top = n.getBoundingClientRect().top

                if (navs[i]) {
                    navs[i].classList.remove('active')
                }

                if (
                    top < window.innerHeight / 2 &&
                    top > -window.innerHeight / 3 &&
                    navs[i]
                ) {
                    navs[i].classList.add('active')
                }
            })
        }
    }

    const numberDecline = (number, titles) => {
        const cases = [2, 0, 1, 1, 1, 2];
        return titles[
            (number % 100 > 4 && number % 100 < 20)
                ? 2
                : cases[(number % 10 < 5) ? number % 10 : 5]
        ];
    }

    const downloadPDF = async () => {
        const url = '/competencies/files/als-urban-projects-screen.pdf'
        const res = await fetch(url)
        const blob = await res.blob()
        const blobUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        a.download = 'Дизайн городов.pdf'
        document.body.appendChild(a)
        a.click()
        a.remove()
        URL.revokeObjectURL(blobUrl)
    }

    const fetchApiData = React.useCallback(async () => {
        if (apiData !== null || apiLoading) return;
        
        if (!api_linkToAll) {
            console.warn('api_linkToAll не указан для тега', tag);
            return;
        }
        
        setApiLoading(true);
        try {
            const response = await fetch(api_linkToAll);
            const data = await response.json();
            setApiData(data);
        } catch (error) {
            console.error('Ошибка при загрузке данных API:', error);
        } finally {
            setApiLoading(false);
        }
    }, [apiData, apiLoading, api_linkToAll, tag]);

    const countingAnons = React.useCallback((block) => {
        let count = 0;

        if (block.webname && apiData) {
            try {
                if (block.webname === 'default') {
                    count = apiData.tag_v2?.tag?.cnt || 0;
                } else {
                    const foundItem = apiData.tag_v2?.list?.find((item) => item.web_name === block.webname);
                    count = foundItem?.cnt || 0;
                }
            } catch (error) {
                console.error('Ошибка при обработке данных API:', error);
            }
        }

        if (count === 0) {
            if (block.anonsSlider) {
                count = block.anonsSlider.reduce((total, item) => {
                    return total + item.split(',').length;
                }, 0);
            } else if (block.mobileSlider) {
                count = block.mobileSlider.reduce((total, item) => {
                    return total + item.split(',').length;
                }, 0);
            } else if (block.carousel) {
                count = block.carousel.length;
            }
        }

        return count;
    }, [apiData]);

    const shouldShowNotShowClass = React.useCallback((block) => {
        if (!block.webname) {
            return false;
        }
        return apiLoading || apiData === null;
    }, [apiLoading, apiData]);

    const blocksRef = React.useRef([])
    const navsRef = React.useRef([])

    React.useEffect(() => {
        const onScroll = () => {
            showingNavigation()
            highlightNavigation()
        }

        const onLoad = () => {
            contentBlocks.forEach(el => {
                if (el.id) {
                    blocksRef.current.push(document.getElementById(el.id))
                    navsRef.current.push(document.querySelector('.sticky-nav-' + el.id))
                }
            })
            highlightNavigation()
        }

        window.addEventListener('scroll', onScroll)
        window.addEventListener('load', onLoad)

        return () => {
            window.removeEventListener('scroll', onScroll)
            window.removeEventListener('load', onLoad)
        }
    }, [contentBlocks])

    React.useEffect(() => {
        const hasWebname = contentBlocks?.some(block => block.webname);
        if (hasWebname && api_linkToAll) {
            fetchApiData();
        }
    }, [contentBlocks, fetchApiData, api_linkToAll]);

    return (
        <React.Fragment>
            <div className="category-target">

                {/* Начальный экран */}
                <div className='preview' ref={preview} style={{ '--сontentColor': сontentColor }}>
                    <h1 className='preview__title' dangerouslySetInnerHTML={{ __html: title }} />
                    <p className='preview__subtitle' dangerouslySetInnerHTML={{ __html: subTitle }} />
                    <div className='preview__buttons'>
                        <a href='#contact' className='preview__button'>{goToTalkText}</a>
                        {
                            presentation && 
                            <div 
                                onClick={() => downloadPDF(presentation)} 
                                className='preview__button file-button'
                            >
                                {downloadFileText}
                            </div>
                        }
                    </div>

                    {tag == 'urban' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={urbanPoster}><source src={urbanVideo} /></video>}
                    {tag == 'retail' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={retailPoster}><source src={retailVideo} /></video>}
                    {tag == 'sport' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={sportPoster}><source src={sportVideo} /></video>}
                    {tag == 'fmcg' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={fmcgPoster}><source src={fmcgVideo} /></video>}
                    {tag == 'industry' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={industryPoster}><source src={industryVideo} /></video>}
                    {tag == 'real-estate' && <video playsInline webkit-playsinline autoPlay muted loop controls={false} disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" poster={realPoster}><source src={realVideo} /></video>}
                </div>

                {/* Вариации блока */}
                <div className='content' style={{ '--сontentColor': сontentColor }}>
                    {
                        contentBlocks && contentBlocks.map((block, index) => {
                            const notShowClass = shouldShowNotShowClass(block) ? 'not-show' : '';
                            
                            return (
                                <div 
                                    key={block.id || index} 
                                    className={`content-block-wrapper ${block.marquee ? 'marquee-content' : ''}`} 
                                    style={{ 
                                        '--color': sideColor || block.sideColor, 
                                        '--zindex': contentBlocks.length - index, 
                                        '--paddingTopLarge': (block.decorImage?.large?.paddingTop ?? 0),
                                        '--paddingTopMiddle': (block.decorImage?.middle?.paddingTop ?? 0),
                                        '--paddingTopSmall': (block.decorImage?.small?.paddingTop ?? 0),
                                        '--yShiftLarge': (block.decorImage?.large?.yShift ?? 0),
                                        '--yShiftMiddle': (block.decorImage?.middle?.yShift ?? 0),
                                        '--yShiftSmall': (block.decorImage?.small?.yShift ?? 0)
                                    }}
                                >
                                    <div
                                        className={`content-block content-block-${index}`}
                                        id={block.id}
                                    >
                                        {/* Заголовок блока */}
                                        <h2 className='content-block__title' dangerouslySetInnerHTML={{ __html: block.title }} />
                                        
                                        {/* Описание блока */}
                                        <div className='content-block__subtitle-wrapper'>
                                            <p className='content-block__subtitle' dangerouslySetInnerHTML={{ __html: block.subTitle }} />
                                            {/* Ссылка на все проекты (десктопный вариант) */}
                                            {
                                                block.linkToAll && (
                                                    <a
                                                        className={`link-to-all-desktop ${notShowClass}`}
                                                        target='_blank'
                                                        href={block.linkToAll}
                                                    >
                                                        {countingAnons(block)} {numberDecline(countingAnons(block), ['проект', 'проекта', 'проектов'])}
                                                    </a>
                                                )
                                            }
                                        </div>

                                        {/* Слайдер кружочками */}
                                        {block.circleSlider && <CircleSlider items={block.circleSlider} />}

                                        {/* Список ссылок */}
                                        <div className='scroll-list'>
                                            <ul>
                                                {
                                                    block.scrollList && block.scrollList.map((item) => {
                                                        return (
                                                            <li key={item.link || item.name}>
                                                                <a
                                                                    href={item.link}
                                                                    target='_blank'
                                                                    rel='noreferrer'>
                                                                    {item.name}
                                                                </a>
                                                            </li>
                                                        )
                                                    })
                                                }
                                            </ul>
                                        </div>

                                        {/* Слайдер анонсов (десктопный) */}
                                        {block.anonsSlider && <AnonsSlider worksId={block.anonsSlider} sideColorLast={block.sliderColorLast || 'rgb(60, 72, 222)'} sideColorNext={block.sliderColorNext || 'rgb(60, 72, 222)'} className="anons-slider-desktop" />}

                                        {/* Слайдер анонсов (мобильный) */}
                                        {
                                            block.anonsSliderMobile &&
                                            <AnonsSlider
                                                worksId={block.anonsSliderMobile || block.anonsSlider}
                                                className="anons-slider-mobile"
                                                sideColorNext={block.sliderColorNext || 'rgb(60, 72, 222)'}
                                            />
                                        }

                                        {/* Слайдер внутри телефона */}
                                        {
                                            block.mobileSlider &&
                                            <MobileSlider
                                                worksId={block.mobileSlider}
                                                className="mobile-slider"
                                                nextColor={block.sliderColorNext || 'rgb(60, 72, 222)'}
                                            />
                                        }

                                        {/* Полоска текста волной */}
                                        {block.marquee && <MarqueeLine text={block.marquee} />}

                                        {/* Бесконечный слайдер логотипов */}
                                        {
                                            block.carousel &&
                                            <Carousel
                                                items={block.carousel}
                                                bg={block.carouselBg}
                                                hover={block.carouselHover}
                                            />
                                        }

                                        {/* Декораторы */}
                                        {block.decorator == 'sport-rotate' && <DecorSportRotate/>}
                                        {block.decorator == 'real-rotate' && <DecorRealRotate/>}
                                        {block.decorator == 'fmcg-complex' && <DecorFMCGComplex/>}
                                        {block.decorator == 'fmcg-logos' && <DecorFMCGLogos/>}
                                        {block.decorator == 'real-logos' && <DecorRealLogos/>}
                                        {block.decorator == 'industry-logos' && <DecorIndustryLogos/>}

                                        {/* Ссылка на все проекты (мобильный вариант) */}
                                        {
                                            block.linkToAll && (
                                                <a
                                                    className={`link-to-all-mobile ${notShowClass}`}
                                                    target='_blank'
                                                    href={block.linkToAll}
                                                >
                                                    {countingAnons(block)} {numberDecline(countingAnons(block), ['проект', 'проекта', 'проектов'])}
                                                </a>
                                            )
                                        }

                                        {block.decorImage && block.decorImage.large && (<img src={block.decorImage.large.image} className='decor-image large-view'/> )}
                                        {block.decorImage && block.decorImage.middle && (<img src={block.decorImage.middle.image} className='decor-image middle-view'/> )}
                                        {block.decorImage && block.decorImage.small && (<img src={block.decorImage.small.image} className='decor-image small-view'/> )}
                                    </div>
                                </div>
                            );
                        })
                    }
                </div>

                {/* Быстрая навигация по блокам */}
                <div className='sticky-gradient' ref={navRef} style={{ '--сontentColor': сontentColor }}>
                    <div className='scroll'>
                        <ul>
                            {
                                contentBlocks && contentBlocks.filter(block => block.id).map((block, index) => (
                                    <div
                                        key={block.id}
                                        className={`sticky-nav sticky-nav-${block.id || 'null'}`}
                                        onClick={() => onNavClick(block.id)}
                                        dangerouslySetInnerHTML={{ __html: block.name || block.title }}
                                    />
                                ))
                            }
                        </ul>
                    </div>
                </div>

                {
                    eng ? <ContactFormEn {...formParams}/> : <ContactFormRu {...formParams}/>
                }

            </div>
        </React.Fragment>
    );
}

export default CategoryTarget;